import { BarChart as MantineBarChart } from '@mantine/charts';
import { Button, Card, Center, Divider, Grid, Modal, Stack, Text, Title } from '@mantine/core';
import { IconArrowsMaximize, IconChartBarOff } from '@tabler/icons-react';
import { useState } from 'react';
import Colors from '../../constants/Colors';

const BarChart = ({ data, title, subTitle, expand, keys, index, type }) => {
  const [expandChartModalOpen, setExpandChartModalOpen] = useState(false);

  // Check if data exists and has actual data points
  const hasData = data && data.data && Array.isArray(data.data) && data.data.length > 0;

  const height = expand ? 125 : 250;

  const noDataPlaceholder = (
    <Center h={height}>
      <Stack align="center" gap="xs">
        <IconChartBarOff size={48} color="var(--mantine-color-dimmed)" stroke={1.5} />
        <Text c="dimmed" size="sm">No Data</Text>
      </Stack>
    </Center>
  );

  // Build series configuration for Mantine Charts
  const series = hasData
    ? keys.map((key, i) => ({
        name: key,
        color: Colors[i % Colors.length],
      }))
    : [];

  const createBarChart = (chartHeight) =>
    hasData ? (
      <div style={{ minHeight: chartHeight, minWidth: 100 }}>
        <MantineBarChart
          h={chartHeight}
          data={data.data}
          dataKey={index}
          series={series}
          tickLine="y"
          withLegend
          legendProps={{ verticalAlign: 'top', horizontalAlign: 'right' }}
        />
      </div>
    ) : (
      noDataPlaceholder
    );

  const modalChart = hasData ? (
    <Grid.Col span={12} style={{ minHeight: 350 }}>
      {createBarChart(350)}
    </Grid.Col>
  ) : null;

  const content = (
    <Grid.Col span={12} style={{ minHeight: height }}>
      {createBarChart(height)}
    </Grid.Col>
  );

  const expandButton =
    expand && hasData ? (
      <Button size="sm" variant="subtle" onClick={() => setExpandChartModalOpen(true)}>
        <IconArrowsMaximize size={16} />
      </Button>
    ) : null;

  const chartContent = (
    <>
      {title ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ flex: 1 }} />
          <Title order={4} style={{ flex: 'none' }}>
            {title}
          </Title>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>{expandButton}</div>
        </div>
      ) : expandButton ? (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{expandButton}</div>
      ) : null}
      {title ? <Divider my="sm" /> : null}
      <Grid>{content}</Grid>
      {subTitle ? (
        <>
          <Divider my="sm" />
          <Title order={5} c="dimmed" ta="center">
            {subTitle}
          </Title>
        </>
      ) : null}
    </>
  );

  return (
    <>
      {type === 'card' ? <Card padding="md">{chartContent}</Card> : <Grid>{chartContent}</Grid>}
      <Modal size="xl" opened={expandChartModalOpen} onClose={() => setExpandChartModalOpen(false)} title={title} keepMounted={false}>
        <Grid>{modalChart}</Grid>
        <Grid justify="flex-end" mt="md">
          <Grid.Col span="content">
            <Button variant="default" onClick={() => setExpandChartModalOpen(false)}>
              Close
            </Button>
          </Grid.Col>
        </Grid>
      </Modal>
    </>
  );
};

export default BarChart;
